const $inject = ['$scope','$routeParams', 'dataService', 'settingsService'];

const lbaMultiSelectCtrl = function ($scope, $routeParams, dataService, settingsService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);

  vm.items = settingsService.options[vm.settings.optionsAt];

  // Copy all functionality
  function copyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = 0;
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;

    document.body.appendChild(textArea);
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copying text command was ' + msg);
    } catch (err) {
      console.log('Oops, unable to copy');
    }

    document.body.removeChild(textArea);
  }

  vm.copyItems = function() {
    if (vm.data && vm.data.length > 0) {
      copyTextToClipboard(vm.data.join(', '));
    }
  };

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

};

lbaMultiSelectCtrl.$inject = $inject;

export default lbaMultiSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaMultiSelect/lbaMultiSelectCtrl.js